const calculateUnits = (data) => {
  const { units_consumed, meter_start_at, meter_stop_at } = data;
  if (units_consumed >= 0) return units_consumed / 1000;
  else if (meter_start_at && meter_stop_at && meter_stop_at > meter_start_at)
    return (meter_stop_at - meter_start_at) / 1000;
  else {
    return 0;
  }
};

const findPrice = (data, station) => {
  return data.power_type === "AC"
    ? station.price_per_unit_ac
    : station.price_per_unit_dc;
};

const calculateItemStats = (
  item,
  units_consumed,
  station,
  start,
  end,
  is_fleet = false
) => {
  const {
    created_at,
    total_amount_spent,
    penalty_fee,
    penalty_paid,
    payment_paid,
    penalty_paid_at,
    payment_paid_at,
    payment_plan,
    start_at,
    stop_at,
  } = item;

  const createdDate = new Date(created_at);
  const createdInRange = createdDate >= start && createdDate <= end;

  let paymentDate = new Date(0);
  if (payment_paid_at > 0) {
    paymentDate = new Date(0);
    paymentDate.setUTCSeconds(payment_paid_at);
  }
  if (
    payment_paid_at === 0 &&
    payment_plan === "Prepaid" &&
    payment_paid === true
  ) {
    paymentDate = new Date(0);
    if (stop_at > 0) {
      paymentDate.setUTCSeconds(stop_at);
    } else {
      paymentDate.setUTCSeconds(start_at);
    }
  }
  let penaltyPaidDate = new Date(0);
  if (penalty_paid_at > 0) {
    penaltyPaidDate = new Date(0);
    penaltyPaidDate.setUTCSeconds(penalty_paid_at);
  }
  if (
    penalty_paid_at === 0 &&
    payment_plan === "Prepaid" &&
    penalty_paid === true
  ) {
    penaltyPaidDate = new Date(0);
    if (stop_at > 0) {
      penaltyPaidDate.setUTCSeconds(stop_at);
    } else {
      penaltyPaidDate.setUTCSeconds(start_at);
    }
  }

  const electricityTotal = createdInRange
    ? units_consumed * (station.price_per_unit_electricity ?? 0)
    : 0;

  let revenueTotal = 0;
  if (is_fleet) {
    if (createdInRange)
      revenueTotal = units_consumed * findPrice(item, station);
  } else if (station.country === "Indonesia") {
    revenueTotal = total_amount_spent;
  } else {
    if (paymentDate >= start && paymentDate <= end) {
      const chargingPaidAmount = payment_paid
        ? penalty_paid
          ? total_amount_spent - penalty_fee
          : total_amount_spent
        : 0;
      revenueTotal = chargingPaidAmount;
    }
    if (penaltyPaidDate >= start && penaltyPaidDate <= end) {
      const penaltyPaidAmount = penalty_paid ? penalty_fee : 0;
      revenueTotal += penaltyPaidAmount;
    }
  }

  const profit = createdInRange ? revenueTotal - electricityTotal : 0;
  let companyProfit = 0;
  if (station.is_profit_sharing && createdInRange) {
    if (station.profit_sharing_type === "Fixed")
      companyProfit = units_consumed * station.profit_sharing_amount;
    else companyProfit = (profit * station.profit_sharing_amount) / 100;
  }
  return {
    electricityTotal,
    revenueTotal,
    profit: profit - companyProfit,
    company_profit: companyProfit,
    withoutCompanyProfit: profit,
  };
};

export const generateTotalRevenue = (data, stationList, start, end) => {
  const results = data.reduce(
    (acc, item) => {
      const station = stationList.find(
        (itemm) => item?.facility_id === itemm?.id
      );

      const itemUnits = item.is_fleet
        ? calculateUnits(item)
        : item?.units_consumed / 1000;
      const stats = calculateItemStats(
        item,
        itemUnits,
        station,
        start,
        end,
        item.is_fleet ? true : false
      );

      return {
        revenue: acc.revenue + stats.revenueTotal,
        units_consumed: acc.units_consumed + itemUnits,
        units_consumed_ac: 0,
        units_consumed_dc: 0,
        electricity_total: acc.electricity_total + stats.electricityTotal,
        company_profit: acc.company_profit + stats.company_profit,
        profit: acc.profit + stats.profit,
        withoutCompanyProfit:
          acc.withoutCompanyProfit + stats.withoutCompanyProfit,
      };
    },
    {
      revenue: 0,
      units_consumed: 0,
      units_consumed_ac: 0,
      units_consumed_dc: 0,
      electricity_total: 0,
      company_profit: 0,
      profit: 0,
      withoutCompanyProfit: 0,
    }
  );

  return results;
};